export default "__VITE_ASSET__CT0rRTB0__"